// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tool-switcher:has(.tool-switcher__link:nth-child(3)) {
  --indicator-width: calc((100% - 6px) / 3);
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.tool-switcher:has(.tool-switcher__link--active:nth-child(2)) {
  --indicator-position: 100%;
}

.tool-switcher:has(.tool-switcher__link--active:nth-child(3)) {
  --indicator-position: 200%;
}

.tool-switcher::before {
  position: absolute;
  top: 3px;
  bottom: 3px;
  left: 3px;
  width: var(--indicator-width);
  border-radius: 999px;
  background: #d4a574;
  content: '';
  opacity: 0;
  transform: translateX(var(--indicator-position));
  transition: transform 0.25s ease, opacity 0.2s ease;
  view-transition-name: tool-switcher-indicator;
}

.tool-switcher:has(.tool-switcher__link--active)::before {
  opacity: 1;
}

::view-transition-group(tool-switcher-indicator) {
  animation-duration: 0.25s;
  animation-timing-function: ease;
}

.header {
  view-transition-name: app-header;
}

html[data-tool-transition-direction='forward']::view-transition-old(root) {
  animation: 0.25s ease both tool-content-exit-left;
}

html[data-tool-transition-direction='forward']::view-transition-new(root) {
  animation: 0.25s ease both tool-content-enter-from-right;
}

html[data-tool-transition-direction='backward']::view-transition-old(root) {
  animation: 0.25s ease both tool-content-exit-right;
}

html[data-tool-transition-direction='backward']::view-transition-new(root) {
  animation: 0.25s ease both tool-content-enter-from-left;
}

@keyframes tool-content-exit-left {
  to {
    transform: translateX(-100vw);
  }
}

@keyframes tool-content-enter-from-right {
  from {
    transform: translateX(100vw);
  }
}

@keyframes tool-content-exit-right {
  to {
    transform: translateX(100vw);
  }
}

@keyframes tool-content-enter-from-left {
  from {
    transform: translateX(-100vw);
  }
}

.tool-switcher__link {
  position: relative;
  z-index: 1;
  text-align: center;
}

@supports selector(:has(*)) {
  .tool-switcher .tool-switcher__link--active {
    background: transparent;
  }
}

.tool-switcher {
  --indicator-width: calc((100% - 6px) / 2);
  --indicator-position: 0%;
  display: inline-grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  position: relative;
  align-items: center;
  padding: 3px;
  border: 1px solid rgba(212, 165, 116, 0.35);
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.22);
}

.tool-switcher__link {
  min-height: 32px;
  padding: 0 12px;
  border-radius: 999px;
  color: #8a8578;
  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 32px;
  text-decoration: none;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.tool-switcher__link:hover {
  color: #e8e4dc;
}

.tool-switcher__link--active {
  background: #d4a574;
  color: #17130f;
}

.tool-switcher__link--active:hover {
  color: #17130f;
}

.tool-switcher__link:focus-visible {
  outline: 2px solid #e8c594;
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/client/components/ToolSwitcher.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,gDAAgD;EAChD,mDAAmD;EACnD,6CAA6C;AAC/C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;EACxB,oBAAoB;EACpB,gDAAgD;EAChD,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,2CAA2C;EAC3C,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,4DAA4D;EAC5D,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,uDAAuD;AACzD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":[".tool-switcher:has(.tool-switcher__link:nth-child(3)) {\n  --indicator-width: calc((100% - 6px) / 3);\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.tool-switcher:has(.tool-switcher__link--active:nth-child(2)) {\n  --indicator-position: 100%;\n}\n\n.tool-switcher:has(.tool-switcher__link--active:nth-child(3)) {\n  --indicator-position: 200%;\n}\n\n.tool-switcher::before {\n  position: absolute;\n  top: 3px;\n  bottom: 3px;\n  left: 3px;\n  width: var(--indicator-width);\n  border-radius: 999px;\n  background: #d4a574;\n  content: '';\n  opacity: 0;\n  transform: translateX(var(--indicator-position));\n  transition: transform 0.25s ease, opacity 0.2s ease;\n  view-transition-name: tool-switcher-indicator;\n}\n\n.tool-switcher:has(.tool-switcher__link--active)::before {\n  opacity: 1;\n}\n\n::view-transition-group(tool-switcher-indicator) {\n  animation-duration: 0.25s;\n  animation-timing-function: ease;\n}\n\n.header {\n  view-transition-name: app-header;\n}\n\nhtml[data-tool-transition-direction='forward']::view-transition-old(root) {\n  animation: 0.25s ease both tool-content-exit-left;\n}\n\nhtml[data-tool-transition-direction='forward']::view-transition-new(root) {\n  animation: 0.25s ease both tool-content-enter-from-right;\n}\n\nhtml[data-tool-transition-direction='backward']::view-transition-old(root) {\n  animation: 0.25s ease both tool-content-exit-right;\n}\n\nhtml[data-tool-transition-direction='backward']::view-transition-new(root) {\n  animation: 0.25s ease both tool-content-enter-from-left;\n}\n\n@keyframes tool-content-exit-left {\n  to {\n    transform: translateX(-100vw);\n  }\n}\n\n@keyframes tool-content-enter-from-right {\n  from {\n    transform: translateX(100vw);\n  }\n}\n\n@keyframes tool-content-exit-right {\n  to {\n    transform: translateX(100vw);\n  }\n}\n\n@keyframes tool-content-enter-from-left {\n  from {\n    transform: translateX(-100vw);\n  }\n}\n\n.tool-switcher__link {\n  position: relative;\n  z-index: 1;\n  text-align: center;\n}\n\n@supports selector(:has(*)) {\n  .tool-switcher .tool-switcher__link--active {\n    background: transparent;\n  }\n}\n\n.tool-switcher {\n  --indicator-width: calc((100% - 6px) / 2);\n  --indicator-position: 0%;\n  display: inline-grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  position: relative;\n  align-items: center;\n  padding: 3px;\n  border: 1px solid rgba(212, 165, 116, 0.35);\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.22);\n}\n\n.tool-switcher__link {\n  min-height: 32px;\n  padding: 0 12px;\n  border-radius: 999px;\n  color: #8a8578;\n  font-family: 'Instrument Sans', 'Helvetica Neue', sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 32px;\n  text-decoration: none;\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.tool-switcher__link:hover {\n  color: #e8e4dc;\n}\n\n.tool-switcher__link--active {\n  background: #d4a574;\n  color: #17130f;\n}\n\n.tool-switcher__link--active:hover {\n  color: #17130f;\n}\n\n.tool-switcher__link:focus-visible {\n  outline: 2px solid #e8c594;\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
